// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"252":"css/app","284":"css/mdb-pro-auto","714":"css/page_view","768":"css/mdb-pro","860":"custom/kisogawa/css/kisogawa"}[chunkId] + ".css";
};